import React, {Component} from 'react'
import {Button} from 'antd';

/**
 * 下一步
 * 示例：
 * <NextStep max={6} okText="保存" onCancel={this.cancel} onOk={this.submit}
 *  onChange={this.nextWithCheck}
 *  activeIndex={this.state.activeTabKey} loading={this.state.saveLoading}/>
 */
let defaultCancelText = "取消";
let defaultOkText = "确定";

class NextStep extends Component {

    constructor(props) {
        super(props);
        this.stepChange = this.stepChange.bind(this);
        this.min = Number(this.props.min ? this.props.min : 1);
        this.max = Number(this.props.max);
        this.state = {
            activeIndex: this.props.activeIndex ? Number(this.props.activeIndex) : this.min,
            loading: this.props.loading
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let newActiveIndex = Number(nextProps.activeIndex);
        if (newActiveIndex !== this.state.activeIndex) {
            this.setState({
                activeIndex: newActiveIndex,
                loading: nextProps.loading
            });
        } else {
            this.setState({
                loading: nextProps.loading
            });
        }
    }

    stepChange(deta) {
        let activeIndex = this.state.activeIndex + Number(deta);
        if (activeIndex < this.min) {
            activeIndex = this.min;
        }
        if (activeIndex > this.max) {
            activeIndex = this.max;
        }
        if (this.props.onChange) {
            if (this.props.onChange(activeIndex)) {
                this.setState({
                    activeIndex: activeIndex
                });
            }
        } else {
            this.setState({
                activeIndex: activeIndex
            });
        }
    }


    render() {
        return (
            <span>
                {
                    this.state.activeIndex === this.min ?
                        (this.props.noCancel ? '' : <Button
                            onClick={this.props.onCancel}>{this.props.cancelText ? this.props.cancelText : defaultCancelText}</Button>) :
                        <Button onClick={this.stepChange.bind(this, -1)}>上一步</Button>
                }
                {
                    this.state.activeIndex === this.max ?
                        <Button type="primary"
                                onClick={this.props.onOk}
                                loading={this.state.loading}>{this.props.okText ? this.props.okText : defaultOkText}</Button> :
                        <Button type="primary" onClick={this.stepChange.bind(this, 1)}>下一步</Button>
                }
            </span>
        )
    }
}

export default NextStep